import { useState, useEffect } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { RiDeleteBin5Fill, RiDeleteBin6Line } from "react-icons/ri";
import { MdGroups2, MdPerson } from "react-icons/md";
import { FaArrowRotateLeft, FaEye, FaCircleInfo, FaArrowRightFromBracket } from "react-icons/fa6";
import { LuFileSpreadsheet, LuClock9 } from "react-icons/lu";
import { BsChatDots } from "react-icons/bs";
import { PiChecksBold } from "react-icons/pi";
import { FaCheck } from "react-icons/fa6";
import { LuMapPin } from "react-icons/lu";
import Tooltip from "../Tooltip";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return isMobile;
};

const ListIcon = ({
  title = "",
  handler = () => {},
  type = "",
  disabled = false,
  className = "",
  color = "",
}) => {
  const isMobile = useIsMobile();
  const tooltipContent = !disabled && !isMobile ? title : "";
  return (
  <Tooltip content={tooltipContent} position="top">
    <span
      //   title={!disabled ? title : ""}
      className={`${disabled ? "cursor-not-allowed opacity-30" : "cursor-pointer"} ${className}`}
      role="button"
      tabIndex={disabled ? -1 : 0} // Disable focus when disabled
      aria-label={title}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) handler();
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (!disabled && (e.key === "Enter" || e.key === " ")) handler();
      }}
      style={disabled ? { pointerEvents: "none" } : {}} // Disable pointer events
    >
      {type === "edit" && <FaPencilAlt color="#00acc1" size="15" />}
      {["delete", "remove"].includes(type) && (
        // <RiDeleteBin5Fill color="#fc0505" size="15" />
        <RiDeleteBin6Line color="#fc0505" size="15" />
      )}
      {["group", "location"].includes(type) && (
        <MdGroups2 color="#3cc9b0" size="18" />
      )}
      {["care-co", "single", "person"].includes(type) && (
        <MdPerson color="#3cc9b0" size="18" />
      )}
      {type === "active" && <FaArrowRotateLeft color="#3cc9b0" size="15" />}
      {["view_activites", "time"].includes(type) && (
        <LuClock9 color="#3cc9b0" size="15" />
      )}
      {type === "review" && <BsChatDots color="#3cc9b0" size="15" />}
      {type === "info" && <FaCircleInfo color="#3cc9b0" size="15" />}
      {type === "view_bill" && <FaEye color="#3cc9b0" size="15" />}
      {type === "create" && <LuFileSpreadsheet color="#3cc9b0" size="15" />}
      {type === "approved" && <PiChecksBold color="#3cc9b0" size="15" />}
      {type === "review_and_approve" && <FaCheck color="#3cc9b0" size="15" />}
      {type === "check-in" && <LuMapPin color={color || "#3cc9b0"} size="15" />}
      {type === "check-out" && <FaArrowRightFromBracket color={color || "#3cc9b0"} size="15" />}
    </span>
  </Tooltip>
  );
};

export default ListIcon;
